import { TrendingUp, TrendingDown, AlertTriangle, Info, Sparkles } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import type { Insight } from '@/lib/statistics'

type Props = { insights: Insight[] }

const ICON_BY_LEVEL = {
  warn: AlertTriangle,
  info: Info,
  good: TrendingDown,
} as const

const TONE_BY_LEVEL = {
  warn: 'text-destructive',
  info: 'text-amber-600 dark:text-amber-500',
  good: 'text-emerald-600 dark:text-emerald-500',
} as const

export function InsightsCard({ insights }: Props) {
  if (insights.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-1.5 text-sm">
            <Sparkles className="h-4 w-4 text-muted-foreground" />
            気になるポイント
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            今月は特に目立った変化はありません。普段通りのペースです。
          </p>
        </CardContent>
      </Card>
    )
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-1.5 text-sm">
          <Sparkles className="h-4 w-4 text-muted-foreground" />
          気になるポイント
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-3">
          {insights.map((insight) => {
            const Icon =
              insight.id === 'total-vs-baseline' && insight.title.includes('+')
                ? TrendingUp
                : ICON_BY_LEVEL[insight.level]
            return (
              <li key={insight.id} className="flex items-start gap-2.5">
                <Icon className={cn('mt-0.5 h-4 w-4 shrink-0', TONE_BY_LEVEL[insight.level])} />
                <div className="min-w-0 flex-1">
                  <div className="text-sm font-medium leading-tight">{insight.title}</div>
                  {insight.detail && (
                    <div className="mt-0.5 text-xs text-muted-foreground tabular-nums">
                      {insight.detail}
                    </div>
                  )}
                </div>
              </li>
            )
          })}
        </ul>
      </CardContent>
    </Card>
  )
}
